import axios from "axios";
import { DataGrid } from "devextreme-react";
import {
  Column,
  Editing,
  Form,
  LoadPanel,
  Popup,
  Scrolling,
  SearchPanel,
  Selection,
  Texts,
} from "devextreme-react/data-grid";
import { Label, RequiredRule, SimpleItem } from "devextreme-react/form";
import CustomStore from "devextreme/data/custom_store";
import DataSource from "devextreme/data/data_source";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

export default function JobInformation() {
  const [dataSource, setDataSource] = useState(null);
  const [jdDataSource, setJdDataSource] = useState(null);
  const [responsibDataSource, setResponsibDataSource] = useState(null);

  const userInfo = useSelector((state) => state.userInfo);

  const jobInfoGridRef = useRef(null);

  let jd = null;

  useEffect(async () => {
    setDataSource(
      new CustomStore({
        key: "SEQ",
        load: async () => {
          const result = await axios.get(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/personnelInfo/jdInfo/${userInfo.employeeNo}`
          );

          return result.data;
        },
        insert: async (values) => {
          await axios.post(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/personnelInfo/jdInfo/${userInfo.employeeNo}`,
            values
          );
        },
        update: async (key, values) => {
          await axios.put(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/personnelInfo/jdInfo/${userInfo.employeeNo}/${key}`,
            values
          );
        },
        remove: async (key) => {
          await axios.delete(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/personnelInfo/jdInfo/${userInfo.employeeNo}/${key}`
          );
        },
        errorHandler: (error) => {
          if (error.message == "Request failed with status code 409") {
            error.message = `The job information is duplicated.`;
          }
        },
      })
    );

    const result = await axios.get(
      `${process.env.REACT_APP_BECCO_API_URL}/api/employee/jd`
    );

    setJdDataSource(result.data);

    const result2 = await axios.get(
      `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/personnelInfo/jdInfo/responsib`
    );

    setResponsibDataSource(
      new DataSource({
        store: result2.data,
        type: "array",
        key: ["jd", "responsib"],
      })
    );
  }, []);

  const onCustomItemCreating = (args) => {
    if (!args.text) {
      args.customItem = null;
      return;
    }

    const newResponsib = {
      // jd: args.text,
      jd: jd,
      responsib: args.text,
    };

    args.customItem = responsibDataSource
      .store()
      .insert(newResponsib)
      .then(() => responsibDataSource.load())
      .then(() => newResponsib)
      .catch((error) => {
        throw error;
      });
  };

  const setCellValue = (newData, value) => {
    newData.jd = value;
  };

  const customizeItem = (item) => {
    if (item) {
      let gridInstance = jobInfoGridRef.current.instance;
      let editRowKey = gridInstance.option("editing.editRowKey");
      let index = gridInstance.getRowIndexByKey(editRowKey);
      index = index === -1 ? 0 : index;

      if (item.dataField == "responsib") {
        jd = gridInstance.cellValue(index, "jd");

        responsibDataSource.filter(["jd", "=", jd]);

        responsibDataSource.load();
      }
    }
  };

  const onInitNewRow = (e) => {
    const key = jobInfoGridRef.current.instance.getKeyByRowIndex(0);

    if (key) {
      e.component.selectRows(key, true);
      e.data = jobInfoGridRef.current.instance.getSelectedRowsData()[0];
    }
  };

  return (
    <DataGrid
      id="jobInfoGrid"
      ref={jobInfoGridRef}
      dataSource={dataSource}
      keyExpr="SEQ"
      rowAlternationEnabled={true}
      showBorders={true}
      showColumnLines={true}
      allowColumnResizing={true}
      columnAutoWidth={true}
      wordWrapEnabled={true}
      allowColumnReordering={true}
      style={{
        maxHeight: "calc(100vh - 180px)",
        marginLeft: "10px",
        marginRight: "10px",
      }}
      hoverStateEnabled={true}
      showColumnHeaders={true}
      onInitNewRow={onInitNewRow}
    >
      <LoadPanel enabled={true} />

      <SearchPanel visible={true} />

      <Scrolling mode={"virtual"} showScrollbar={"always"} />

      <Selection mode="single" />

      <Editing
        mode={"popup"}
        allowAdding={true}
        allowUpdating={true}
        allowDeleting={true}
      >
        <Texts
          confirmDeleteTitle={"Delete the Job Info."}
          confirmDeleteMessage={
            "Are you sure you want to delete this job info?"
          }
        />
        <Popup
          title={"Job Info."}
          showTitle={true}
          height={"auto"}
          width={1200}
        />
        <Form
          labelMode={"outside"}
          showColonAfterLabel={false}
          labelLocation="top"
          minColWidth={300}
          colCount={2}
          colCountByScreen={{ sm: 2, md: 4 }}
          screenByWidth={(width) => {
            return width < 720 ? "sm" : "md";
          }}
          validationGroup="jobInfoGroup"
          height={"100%"}
          customizeItem={customizeItem}
        >
          <SimpleItem
            dataField={"apptDate"}
            editorType="dxDateBox"
            editorOptions={{
              type: "date",
              displayFormat: "yyyy-MM-dd",
              dateSerializationFormat: "yyyy-MM-dd",
              showClearButton: true,
            }}
          >
            {/* <Label text={"발령일"} /> */}
            <Label text={"Appointment Date"} />
            <RequiredRule message={"* Appointment date is required."} />
          </SimpleItem>
          <SimpleItem
            dataField={"jd"}
            editorType="dxSelectBox"
            editorOptions={{
              showClearButton: true,
              dataSource: jdDataSource,
              valueExpr: "jd",
              displayExpr: "name",
            }}
          >
            {/* <Label text={"직책"} /> */}
            <Label text={"Position"} />
            {/* <RequiredRule message={"* 직책을 입력해주세요."} /> */}
            <RequiredRule message={"* Position is required."} />
          </SimpleItem>
          <SimpleItem
            dataField={"responsib"}
            editorType="dxSelectBox"
            editorOptions={{
              dataSource: responsibDataSource,
              // dataSource: getResponsibDataSource,
              valueExpr: "responsib",
              displayExpr: "responsib",
              showClearButton: true,
              placeholder: "직접입력가능",
              acceptCustomValue: true,
              onCustomItemCreating: onCustomItemCreating,
            }}
            colSpan={2}
          >
            {/* <Label text={"담당업무"} /> */}
            <Label text={"Responsibilities"} />
          </SimpleItem>
        </Form>
      </Editing>

      <Column
        dataField={"apptDate"}
        // caption="발령일"
        caption="Appointment Date"
        dataType="date"
        format="yyyy-MM-dd"
        editorOptions={{
          dateSerializationFormat: "yyyy-MM-dd",
        }}
        width={150}
        alignment={"center"}
      />
      <Column
        dataField={"jd"}
        caption=""
        setCellValue={setCellValue}
        visible={false}
      />
      {/* <Column dataField={"name"} caption="직책" /> */}
      <Column
        dataField={"name"}
        caption="Position"
        width={200}
        alignment={"center"}
      />
      {/* <Column dataField={"responsib"} caption="담당업무"> */}
      <Column dataField={"responsib"} caption="Responsibilities" />
    </DataGrid>
  );
}
